// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderFooter from "../shared/PlaceOrderFooter.bs.js";
import * as VehicleDetailsSM from "../../../app/state-machine/VehicleDetailsSM.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as LoadingVehicleCards from "./LoadingVehicleCards.bs.js";
import * as VehicleQuotationsSM from "../../../app/state-machine/VehicleQuotationsSM.bs.js";
import * as PickAndDropSectionCmp from "./PickAndDropSectionCmp.bs.js";
import * as PlaceOrderDataMachine from "../../../app/data-machine/PlaceOrderDataMachine.bs.js";
import * as VehicleQuotationPayload from "../../../app/api-model/VehicleQuotationPayload.bs.js";
import * as VehicleSectionSectionCmp from "./VehicleSectionSectionCmp.bs.js";
import * as ErrorVehicleSelectionSectionCmp from "./ErrorVehicleSelectionSectionCmp.bs.js";

function VehicleSelectionCmp(Props) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = PlaceOrderContext.useContext(undefined);
  var state = match$1.state;
  var restricted_vehicles = state.restricted_vehicles;
  var customerInfo = state.customerInfo;
  var geo_region = state.geo_region;
  var selectedVehicle = state.selectedVehicle;
  var pickupAddress = state.pickupAddress;
  var dispatch = match$1.dispatch;
  var match$2 = React.useReducer(VehicleDetailsSM.reducer, /* Init */0);
  var vehicleDetailsDispatch = match$2[1];
  var vehicleDetails = match$2[0];
  var match$3 = React.useReducer(VehicleQuotationsSM.reducer, /* Init */0);
  var vehicleQuotationsDispatch = match$3[1];
  var vehicleQuotations = match$3[0];
  var fetchVehicleDetails = function (param) {
    var v = pickupAddress.latLng;
    return PlaceOrderDataMachine.fetchVehicleDetails(geo_region !== undefined ? String(geo_region.id) : "", v !== undefined ? v : ({
                    lat: 0.00,
                    lng: 0.00
                  }), customerInfo.mobile, country, (function (vehicles) {
                  Curry._1(vehicleDetailsDispatch, {
                        TAG: /* FetchVehicleDetailsSuccess */0,
                        _0: vehicles
                      });
                  Curry._1(dispatch, {
                        TAG: /* SetVehicles */11,
                        _0: vehicles.vehicles
                      });
                  var vehicleIds = vehicles.vehicles.vehicle_ids;
                  var availableVehicleIds = vehicleIds.filter(function (id) {
                        var match = restricted_vehicles.find(function (e) {
                              return e === id;
                            });
                        return match === undefined;
                      });
                  var payload = VehicleQuotationPayload.getData(undefined, state, availableVehicleIds);
                  return PlaceOrderDataMachine.fetchVehicleQuotation(payload, country, (function (data) {
                                return Curry._1(vehicleQuotationsDispatch, {
                                            TAG: /* FetchVehicleQuotationsSuccess */0,
                                            _0: data
                                          });
                              }), (function (error) {
                                return Curry._1(vehicleQuotationsDispatch, {
                                            TAG: /* FetchVehicleQuotationsFailed */1,
                                            _0: error
                                          });
                              }));
                }), (function (error) {
                  return Curry._1(vehicleDetailsDispatch, {
                              TAG: /* FetchVehicleDetailsFailed */1,
                              _0: error
                            });
                }));
  };
  React.useEffect((function () {
          fetchVehicleDetails(undefined);
          
        }), []);
  var onSelectVehicle = function (vehicle) {
    PlaceOrderGaConfig.publishEvent({
          category: /* VehicleSelection */2,
          action: "Vehicle Selected Manually",
          label: "1_" + customerInfo.mobile,
          value: undefined,
          nonInteraction: undefined
        }, country);
    return Curry._1(dispatch, {
                TAG: /* SetSelectedVehicle */2,
                _0: vehicle
              });
  };
  var onRefreshList = function (param) {
    PlaceOrderGaConfig.publishEvent({
          category: /* VehicleSelection */2,
          action: "Vehicle Selection Reload",
          label: "1_" + customerInfo.mobile,
          value: undefined,
          nonInteraction: undefined
        }, country);
    Curry._1(vehicleDetailsDispatch, /* SetToInit */0);
    Curry._1(vehicleQuotationsDispatch, /* SetToInit */0);
    return fetchVehicleDetails(undefined);
  };
  var tmp;
  var exit = 0;
  var exit$1 = 0;
  if (typeof vehicleDetails === "number") {
    exit$1 = 2;
  } else if (vehicleDetails.TAG === /* Data */0) {
    if (typeof vehicleQuotations === "number") {
      exit = 1;
    } else if (vehicleQuotations.TAG === /* Data */0) {
      tmp = React.createElement(VehicleSectionSectionCmp.make, {
            vehicles: vehicleDetails._0,
            quotations: vehicleQuotations._0,
            selectedVehicle: selectedVehicle,
            onSelectVehicle: onSelectVehicle
          });
    } else {
      exit$1 = 2;
    }
  } else {
    tmp = React.createElement(ErrorVehicleSelectionSectionCmp.make, {
          onRefreshList: onRefreshList
        });
  }
  if (exit$1 === 2) {
    if (typeof vehicleQuotations === "number" || vehicleQuotations.TAG === /* Data */0) {
      exit = 1;
    } else {
      tmp = React.createElement(ErrorVehicleSelectionSectionCmp.make, {
            onRefreshList: onRefreshList
          });
    }
  }
  if (exit === 1) {
    tmp = React.createElement(LoadingVehicleCards.make, {});
  }
  var match$4 = selectedVehicle.vehicle_id;
  return React.createElement("div", {
              className: "place_order_step__2"
            }, React.createElement("div", {
                  className: "content-section"
                }, React.createElement(PickAndDropSectionCmp.make, {}), tmp), React.createElement(PlaceOrderFooter.make, {
                  handleNextButton: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* VehicleSelection */2,
                            action: "Next",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(dispatch, {
                                  TAG: /* ChangeCurrentStep */0,
                                  _0: /* ConfirmOrderStep */2
                                });
                    }),
                  handleBackButton: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* VehicleSelection */2,
                            action: "Back",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(dispatch, {
                                  TAG: /* ChangeCurrentStep */0,
                                  _0: /* PickupDropStep */0
                                });
                    }),
                  showBackButton: true,
                  isDisabled: match$4 === -1
                }));
}

var make = VehicleSelectionCmp;

export {
  make ,
  
}
/* react Not a pure module */
